import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import '../../styles/QuoteProposal.css';
const ProposalViewPage: React.FC = () => {
    const { transactionId } = useParams<{
        transactionId: string;
    }>();
    const [GeneratedProposal, setGeneratedProposal] = useState<React.ComponentType<any> | null>(null);
    useEffect(() => {
        import('./GeneratedProposal')
            .then(m => setGeneratedProposal(() => m.default))
            .catch(() => { });
    }, []);
    if (!transactionId) {
        return (<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', color: '#888', fontFamily: 'Poppins, sans-serif' }}>
        <p>Invalid proposal link.</p>
      </div>);
    }
    return (<div style={{ height: '100vh', overflowY: 'auto', background: 'var(--bg-primary, #080816)', padding: '24px 0' }}>
      {GeneratedProposal ? (<GeneratedProposal transactionId={transactionId} isEditable={false} isPublic={true} isGeneratingPdf={false} onPdfDataReady={() => { }} proposalTeamMembers={[]} customBlocksData={[]} videoUrl=""/>) : (<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', color: '#888', fontFamily: 'Poppins, sans-serif', gap: 12 }}>
          <div className="qp-spinner"/>
          <span>Loading proposal…</span>
        </div>)}
    </div>);
};
export default ProposalViewPage;
